import React from 'react'
import { Link } from "react-router-dom";

import "../styles/homeNavbar.css"

function HomepageNavbar() {
    return (
        <div>
             <div className="h-link-cont">
          <Link to="/" className="ilink">
            Home
          </Link>
          <Link to="/about" className="ilink">
            About
          </Link>
          <Link to="/resume" className="ilink">
            Resume
          </Link>
          <Link to="/services" className="ilink">
            Services
          </Link>
          {/* <Link to="/portfolio" className="ilink">
            Portfolio
          </Link> */}
          <Link to="/contact" className="ilink">
            Contact
          </Link>
        </div>
        </div>
    )
}

export default HomepageNavbar
